<template>
    <component :is="componentName" :list="list" :title="title" :type="className" :content="content" :trans="trans" />
</template>

<script>
    import * as components from '../'

    export default {
        props: {
            name: {
                type: String,
                required: true
            },
            list: Array,
            title: String,
            content: String,
            className: String,
            trans: Object,
        },

        computed: {
            // Convert kebab-case to PascalCase for dynamic component resolution
            componentName() {
                return this.name
                    .split('-')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join('');
            }
        },

        components: {
            ...components
        },
    }
</script>
